import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { LinksPage } from '@/features/settings/ui/LinksPage';

export const Route = createFileRoute('/_authenticated/settings/links')({ validateSearch: z.object({ s: sortSearchParam }), component: LinksPage });
